export const formatTimestamp = timestamp => {
  const dateTime = new Date(timestamp * 1000);
  return `${dateTime.toISOString()}`;
}